import { Route, Routes } from 'react-router';
import { routes } from '@/constants/routes';
import AdminLayout from '@/components/layouts/AdminLayout';
import AdminHome from './Home';
import AdminRoutes from './RoutesList';
import CreateEditRoute from './CreateEditRoute';
import CreateEditContent from './CreateEditContent';
import RouteDetail from './RouteDetail';
import UsersList from './UsersList';
import ReorderRoutes from './ReorderRoutes';
import StageDetail from './StageDetail';
import CreateEditStageContent from './CreateEditStageContent';

const Admin = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<AdminHome />} />
        <Route path={routes.admin.routes.r_root} element={<AdminRoutes />} />
        <Route path={routes.admin.routes.r_create} element={<CreateEditRoute />} />
        <Route path={routes.admin.routes.r_detail} element={<RouteDetail />} />
        <Route path={routes.admin.routes.r_edit} element={<CreateEditRoute />} />
        <Route path={routes.admin.routes.r_reorder} element={<ReorderRoutes />} />
        <Route path={routes.admin.routes.contents.r_detail} element={<CreateEditContent />} />
        <Route path={routes.admin.routes.stages.r_detail} element={<StageDetail />} />
        <Route path={routes.admin.routes.stages.contents.r_detail} element={<CreateEditStageContent />} />
        <Route path={routes.admin.users.r_root} element={<UsersList />} />
      </Route>
    </Routes>
  );
};

export default Admin;
